import { PropertyTypes } from "epsm-api-types";
import type { PriceDaily } from "epsm-api-types/models";
import { formatValue } from "@/components/widgets/helpers/FormattingHelpers";
import type { ReportCode } from "../../../types";

export function getPricePointByReportCode(
	price: PriceDaily,
	reportCode: ReportCode,
	takeOpedPrice: boolean,
) {
	let pricePoint: number | undefined;

	switch (reportCode) {
		case "DMT":
		case "AMC":
			pricePoint = takeOpedPrice ? price.adj_open : price.adj_close;

			break;
		case "BTO":
			pricePoint = price.adj_close;
			break;
	}

	return formatValue(pricePoint || 0, PropertyTypes.NUMBER, {
		useGrouping: false,
	});
}
